import { addSideEffects } from '@poa/state';
import { fetchGifts, refreshGifts, changeFilter } from './gifts.actions';

addSideEffects(fetchGifts, async (_, { actions, env, store }) => {
  try {
    const giftsGrouping = await env.api.gifts.fetchGiftsGrouping();
    actions.giftsActions.resetGrouping(giftsGrouping);

    const gifts = await env.api.gifts.fetchGifts(store.gifts.filters.filter);
    actions.giftsActions.fetchGiftsSuccess(gifts);
  } catch (e) {
    console.error(e);
    actions.giftsActions.fetchGiftsFailed();
    throw e;
  }
});

addSideEffects(refreshGifts, async (_, { actions, env, store }) => {
  const gifts = await env.api.gifts.fetchGifts(store.gifts.filters.filter);

  actions.giftsActions.fetchGiftsSuccess(gifts);
});

addSideEffects(changeFilter, async ({ filter }, { actions, env }) => {
  try {
    const gifts = await env.api.gifts.fetchGifts(filter);
    actions.giftsActions.fetchGiftsSuccess(gifts);
  } catch (e) {
    console.error(e);
    actions.giftsActions.fetchGiftsFailed();
    throw e;
  }
});
